export default "__VITE_ASSET__20890b29__"